<template>
    <a
        v-if="platform.platform_url"
        :href="platform.platform_url"
        target="_blank"
        >{{ platform.platform_name }}
        <fa
            icon="fa-link"
            class="text-blue-500"
        />
    </a>
    <div
        v-else
        class="truncate"
    >
        {{ platform.platform_name }}
    </div>
</template>
<script setup lang="ts">
import { Platform } from '@src/types'

defineProps<{
    platform: Platform
}>()
</script>
